import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app.config';

bootstrapApplication(AppComponent, appConfig).then(() => {
  console.log('Application bootstrapped successfully');
}).catch(err => console.error('Error bootstrapping application:', err));

